import React, { } from "react";
import { P_Props } from "./BranchForm.type";
import { SimpleModalHeader, Loading } from "../../../../components";
import { FORM_MODE, BranchInputModel } from "../../../../../models";
import { FormUtil, FormUIUtil, loadCallback } from "../../../../../utils";
import { Form, Field } from "react-final-form";
import { TextField, Grid } from "@material-ui/core";
// import Autocomplete from "@material-ui/lab/Autocomplete";
import { InfoOutlined as InfoOutlinedIcon } from "@material-ui/icons";

const BranchFormPresenter: React.FC<P_Props> = (props) => {
  let submit: any;

  const bindingBranchDataToForm = (data: BranchInputModel) => {
    return {
      title: data.title,
      subTitle: data.subTitle,
      address: data.address,
      tel: data.tel,
      fax: data.fax,
      contact: data.contact,
      longitude: data.longitude,
      latitude: data.latitude,
    };
  };

  return (
    <div className="branch-form">
      <SimpleModalHeader
        title={
          props.mode === FORM_MODE.CREATE ? "New branch" : "Edit branch"
        }
        onClose={() => {
          props.onCancel();
        }}
      />
      {/* <InputTags inputValue={props.tags} onChange={props.handleTagsChange} /> */}

      <div className="branch-form__divide">
        <div className="branch-form__container">
          <div className="branch-form__box">
            {props.loading && <Loading />}
            {!props.loading && (
              <Form
                initialValues={
                  props.initData
                    ? bindingBranchDataToForm(props.initData)
                    : ""
                }
                initialValuesEqual={() => true}
                onSubmit={async (values, form) => {
                  props.onSubmit(values);
                }}
                render={({ handleSubmit, form, pristine }) => {
                  submit = handleSubmit;

                  return (
                    <>
                      <form onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} lg={6}>
                            <Field
                              name="title"
                              validate={FormUtil.Rule.required("Please input title")}
                            >
                              {({ input, meta, ...rest }) => {
                                return FormUIUtil.renderFormItem(
                                  "Title",
                                  <TextField
                                    {...input}
                                    {...rest}
                                    fullWidth
                                    placeholder="Enter branch title"
                                    className="form-text-field"
                                    inputProps={{ className: "input" }}
                                    variant="outlined"
                                    onChange={(e) =>
                                      input.onChange(e.target.value)
                                    }
                                    helperText={
                                      meta.touched ? meta.error : ""
                                    }
                                    error={meta.error && meta.touched}
                                  />, false, true
                                );
                              }}
                            </Field>
                          </Grid>
                          <Grid item xs={12} lg={6}>
                            <Field
                              name="subTitle"
                              validate={FormUtil.Rule.required("Please input subtitle")}
                            >
                              {({ input, meta, ...rest }) => {
                                return FormUIUtil.renderFormItem(
                                  "Subtitle",
                                  <TextField
                                    {...input}
                                    {...rest}
                                    fullWidth
                                    placeholder="Enter branch subtitle"
                                    className="form-text-field"
                                    inputProps={{ className: "input" }}
                                    variant="outlined"
                                    onChange={(e) =>
                                      input.onChange(e.target.value)
                                    }
                                    helperText={
                                      meta.touched ? meta.error : ""
                                    }
                                    error={meta.error && meta.touched}
                                  />, false, true
                                );
                              }}
                            </Field>
                          </Grid>

                          <Grid item xs={12} lg={6}>
                            <Field
                              name="address"
                              validate={FormUtil.Rule.required("Please input address")}
                            >
                              {({ input, meta, ...rest }) => {
                                return FormUIUtil.renderFormItem(
                                  "Address",
                                  <TextField
                                    {...input}
                                    {...rest}
                                    fullWidth
                                    placeholder="Enter branch address"
                                    className="form-text-field"
                                    inputProps={{ className: "input" }}
                                    variant="outlined"
                                    onChange={(e) =>
                                      input.onChange(e.target.value)
                                    }
                                    helperText={
                                      meta.touched ? meta.error : ""
                                    }
                                    error={meta.error && meta.touched}
                                  />, false, true
                                );
                              }}
                            </Field>
                          </Grid>
                          <Grid item xs={12} lg={6}>
                            <Field name="tel">
                              {({ input, meta, ...rest }) => {
                                return FormUIUtil.renderFormItem(
                                  "Tel",
                                  <TextField
                                    {...input}
                                    {...rest}
                                    fullWidth
                                    placeholder="Enter branch telephone number"
                                    className="form-text-field"
                                    inputProps={{ className: "input" }}
                                    variant="outlined"
                                    onChange={(e) =>
                                      input.onChange(e.target.value)
                                    }
                                    helperText={
                                      meta.touched ? meta.error : ""
                                    }
                                    error={meta.error && meta.touched}
                                  />
                                );
                              }}
                            </Field>
                          </Grid>

                          <Grid item xs={12} lg={6}>
                            <Field name="fax">
                              {({ input, meta, ...rest }) => {
                                return FormUIUtil.renderFormItem(
                                  "Fax",
                                  <TextField
                                    {...input}
                                    {...rest}
                                    fullWidth
                                    placeholder="Enter branch fax"
                                    className="form-text-field"
                                    inputProps={{ className: "input" }}
                                    variant="outlined"
                                    onChange={(e) =>
                                      input.onChange(e.target.value)
                                    }
                                    helperText={
                                      meta.touched ? meta.error : ""
                                    }
                                    error={meta.error && meta.touched}
                                  />
                                );
                              }}
                            </Field>
                          </Grid>
                          <Grid item xs={12} lg={6}>
                            <Field
                              name="contact"
                              validate={FormUtil.Rule.required("Please input contact")}
                            >
                              {({ input, meta, ...rest }) => {
                                return FormUIUtil.renderFormItem(
                                  "Contact",
                                  <TextField
                                    {...input}
                                    {...rest}
                                    value={props.tag}
                                    fullWidth
                                    placeholder="Press enter to add a branch contact"
                                    className="form-text-field branch-form--contact"
                                    inputProps={{ className: "input" }}
                                    variant="outlined"
                                    onKeyDown={props.handleKeyDown}
                                    onChange={async (e) => {
                                      await props.handleChange(e);
                                      input.onChange(e.target.value)
                                    }}
                                    helperText={
                                      meta.touched ? meta.error : ""
                                    }
                                    error={meta.error && meta.touched}
                                    InputProps={{
                                      className: "input-adornment",
                                      startAdornment:
                                        <div className="tags-input">
                                          {props.tags.map((tag, index) => (
                                            <div className="tag" key={index}>
                                              {tag}
                                              <button
                                                type="button"
                                                className="delete"
                                                onClick={() => props.handleRemoveTag(tag)}
                                              >
                                              </button>
                                            </div>
                                          ))}
                                        </div>,
                                    }}
                                  />
                                  , false, true
                                );
                              }}
                            </Field>
                          </Grid>

                          <Grid item xs={12} lg={6}>
                            <Field
                              name="longitude"
                              validate={FormUtil.Rule.required("Please input longitude")}
                            >
                              {({ input, meta, ...rest }) => {
                                return FormUIUtil.renderFormItem(
                                  "Longitude",
                                  <TextField
                                    {...input}
                                    {...rest}
                                    fullWidth
                                    placeholder="Enter longitude"
                                    className="form-text-field"
                                    inputProps={{ className: "input" }}
                                    variant="outlined"
                                    onChange={(e) =>
                                      input.onChange(e.target.value)
                                    }
                                    helperText={
                                      meta.touched ? meta.error : ""
                                    }
                                    error={meta.error && meta.touched}
                                  />, false, true
                                );
                              }}
                            </Field>
                          </Grid>
                          <Grid item xs={12} lg={6}>
                            <Field
                              name="latitude"
                              validate={FormUtil.Rule.required("Please input latitude")}
                            >
                              {({ input, meta, ...rest }) => {
                                return FormUIUtil.renderFormItem(
                                  "Latitude",
                                  <TextField
                                    {...input}
                                    {...rest}
                                    fullWidth
                                    placeholder="Enter latitude"
                                    className="form-text-field"
                                    inputProps={{ className: "input" }}
                                    variant="outlined"
                                    onChange={(e) =>
                                      input.onChange(e.target.value)
                                    }
                                    helperText={
                                      meta.touched ? meta.error : ""
                                    }
                                    error={meta.error && meta.touched}
                                  />, false, true
                                );
                              }}
                            </Field>
                          </Grid>
                        </Grid>
                        <Grid item xs={12}>
                          <div className="branch-form-note">
                            <InfoOutlinedIcon style={{ color: "#08C4E3", fontSize: "1.6rem", marginRight: "1.2rem" }} />
                            <div>
                              Right click on the place or area on the Google map. Select latitude and longitude - this will copy the coordinates automatically. <a href="https://support.google.com/maps/answer/18539?co=GENIE.Platform%3DDesktop&hl=en">Learn more</a>
                            </div>
                          </div>
                        </Grid>
                      </form>
                    </>
                  );
                }}
              />
            )}
          </div>
        </div>
      </div>

      <div className="branch-form__footer">
        <button
          className="btn cancel"
          onClick={(e) => {
            e.preventDefault();
            props.onCancel();
          }}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="btn save"
          onClick={(e) => {
            loadCallback(submit, e);
          }}
        >
          {props.mode === FORM_MODE.CREATE ? "Create" : "Save"}
        </button>
      </div>
    </div>
  );
};

export default BranchFormPresenter;
